import Vue from 'vue'
import VueRouter from 'vue-router'
const Layout = () => import('@/layout')

Vue.use(VueRouter)

export const routes = [
	{
		path: '/',
		redirect: '/index',
		hidden: true
	},
	{
		path: '/login',
		name: "Login",
		component: () => import("@/views/login"),
		meta: {
			title: '简脉登录'
		},
		hidden: true
	},
	{
		path: '/index',
		name: "index",
		component: () => import("@/views/index"),
		meta: {
			title: '简脉工作台'
		}
	},
	{
		path: '/share-records',
		name: "shareRecords",
		component: () => import("@/views/share-records"),
		meta: {
			title: '分享记录'
		}
	},
	{
		path: '/sharebean-records',
		name: "sharebeanRecords",
		component: () => import("@/views/sharebean-records"),
		meta: {
			title: '分享豆记录'
		}
	},
	{
		path: '/ai-helper-records',
		name: "aiHelperRecords",
		component: () => import("@/views/ai-helper-records"),
		meta: {
			title: 'AI助理开通记录'
		}
	},
	{
		path: '/ai-usage-spec',
		name: "aiUsageSpec",
		component: () => import("@/views/content-page"),
		meta: {
			title: 'AI工具规范使用说明',
			enTitle: 'AI Usage Spec',
			configType: 5
		}
	},
	{
		path: '/sharebean-guide',
		name: "sharebeanGuide",
		component: () => import("@/views/content-page"),
		meta: {
			title: '分享豆使用说明',
			enTitle: 'Sharebean Guide',
			configType: 4
		}
	},
	{
		path: '/feedback-center',
		name: "feedbackCenter",
		component: () => import("@/views/feedback-center"),
		meta: {
			title: '帮助与反馈'
		}
	},
	{
		path: '/resume-editor',
		name: "resumeEditor",
		component: () => import("@/views/resume-editor"),
		meta: {
			title: '编辑简历'
		}
	},
	{
		path: '/resume-types',
		name: "resumeTypes",
		component: () => import("@/views/resume-types"),
		meta: {
			title: '简历类型管理'
		}
	},
	{
		path: '/career-user-home',
		name: "careerUserHome",
		component: () => import("@/views/career-user-home"),
		meta: {
			title: '用户主页'
		}
	},
	{
		path: '/about-jianmai',
		name: "aboutJianmai",
		component: () => import("@/views/content-page"),
		meta: {
			title: '关于简脉',
			enTitle: 'About JianMai',
			configType: 1
		}
	},
	{
		path: '/invitation-records',
		name: "invitationRecords",
		component: () => import("@/views/invitation-records"),
		meta: {
			title: '邀请/注册记录'
		}
	}
	// {
	// 	path: '/',
	// 	name: "home",
	// 	component: Layout,
	// 	redirect: '/dashboard',
	// 	meta: {
	// 		title: '品康数据大屏',
	// 		icon: 's_home',
	// 		keepAlive: false,
	// 	},
	// 	children: [{
	// 		path: '/dashboard',
	// 		name: 'dashboard',
	// 		component: () => import('@/views/index.vue'),
	// 		meta: {
	// 			title: '首页',
	// 			icon: 's_home',
	// 			keepAlive: false,
	// 			breadList: [{
	// 				title: "首页",
	// 				path: "/dashboard",
	// 			}, ]
	// 		},
	// 	}, ]
	// }
]

const createRouter = () => new VueRouter({
	mode: "hash",
	routes,
})

const router = createRouter()
export function resetRouter() {
	const newRouter = createRouter()
	router.matcher = newRouter.matcher // 新路由实例matcer，赋值给旧路由实例的matcher，（相当于replaceRouter）
}

export default router
